import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faTriangleExclamation } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, IconButton, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import React, { useState } from "react";
import LoadingApp from "../../../components/LoadingApp";
import ModalFeedBack from "../../../components/ModalFeedBack";
import { ModalAgendamentoProps } from "../../../interfaces/props/ModalAgendamentoProps";
import { cancelarAtendimento } from "../../../services/AgendamentoService";
import { cancelaAtendimentoPaVirtual } from "../../../services/SaudeOnlineService";
import ModalAtendimentoCancelado from "./ModalAtendimentoCancelado";
import "./styles.css";
import {
  sxButtonScheduleAction,
  sxCloseIconButton,
  sxModal,
  sxTypographySubTitleModal,
  sxTypographyTitleModal,
} from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import warningIcon from "../../../assets/images/triangle-exclamation.png";
import ModalAction from "../../../components/ModalAction";

const ModalCancelarAtendimento: React.FC<ModalAgendamentoProps> = ({
  showModal,
  handleShowModal,
  agendamento,
  onComplete,
  idAgendaPaVirtual,
}) => {
  const [showModalAtendimentoCancelado, setShowModalAtendimentoCancelado] =
    useState<boolean>(false);
  const [showModalFeedBack, setShowModalFeedBack] = useState<boolean>(false);
  const [showLoading, setShowLoading] = useState<boolean>(false);

  const accessibility = useAccessibility();

  const handleConfirmarCancelamentoAtendimento = async () => {
    handleShowModal();
    if (agendamento) {
      setShowLoading(true);
      let response = await cancelarAtendimento(
        agendamento.id,
        agendamento.idInstal
      );
      setShowLoading(false);
      if (response?.status !== 200) {
        handleShowModalFeedBack();
      } else {
        handleShowAtendimentoCancelado();
      }
    } else if (idAgendaPaVirtual) {
      setShowLoading(true);
      let response = await cancelaAtendimentoPaVirtual(idAgendaPaVirtual);
      setShowLoading(false);
      if (response?.status !== 200) {
        handleShowModalFeedBack();
      } else {
        handleShowAtendimentoCancelado();
      }
    }
  };

  const handleShowAtendimentoCancelado = () => {
    setShowModalAtendimentoCancelado(
      (showModalAtendimentoCancelado) => !showModalAtendimentoCancelado
    );
  };

  const handleShowModalFeedBack = () => {
    setShowModalFeedBack((showModalFeedBack) => !showModalFeedBack);
  };

  return (
    <div>
      <ModalAction
          showModal={showModal}
          handleShowModal={handleShowModal}
          icon={'warning'}
          textOutlinedButton='Voltar'
          textContainedButton='Cancelar'
          title='Cancelar atendimento'
          subTitle='Tem certeza que deseja cancelar seu atendimento?'
          handleOutlinedButton={handleShowModal}
          handleContainedButton={handleConfirmarCancelamentoAtendimento}
        />

      <ModalAtendimentoCancelado
        handleShowModal={handleShowAtendimentoCancelado}
        onComplete={onComplete}
        showModal={showModalAtendimentoCancelado}
      />
      <ModalFeedBack
        showModal={showModalFeedBack}
        handleButtonModal={handleShowModalFeedBack}
        showButtonModal
        icon="error"
        handleShowModal={handleShowModalFeedBack}
        textButton="Voltar para agendamentos"
        title="Erro"
        subTitle="Ocorreu um erro ao cancelar seu atendimento, tente novamente em alguns instantes"
      />
      <LoadingApp showLoading={showLoading} />
    </div>
  );
};

export default ModalCancelarAtendimento;
